module.exports = __webpack_public_path__ + "static/img/newhomedesign.1fb0821.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newhomedesign.jpg
// module id = JUUD
// module chunks = 0